export default {
  GASPING: 'gasping', // หายใจลำบาก
  COUGH: 'cough', // ไอ
  SNIVEL: 'snivel' // น้ำมูก
}
